export default __webpack_public_path__ + "static/media/14t.d67082c1.jpg";